// extracted by mini-css-extract-plugin
module.exports = {"root":"_3ndo4__root","msTeamsConnecting":"_2oN1O__msTeamsConnecting"};